import { getLastMatchedRoute } from 'utils/findMatchedRoutes'

export const ROUTE_ACCESS = {
  PRIVATE: 'private',
  GUEST: 'guest',
  PUBLIC: 'public',
}

export const withAccess = (routes, access) =>
  routes.map((route) => ({
    ...route,
    access: route.access ?? access,
    ...(route.routes
      ? {
          routes: route.routes.map((child) => ({
            ...child,
            access: child.access ?? access,
          })),
        }
      : {}),
  }))

export const isPrivateAccess = (access) => access === ROUTE_ACCESS.PRIVATE

export const isGuestAccess = (access) => access === ROUTE_ACCESS.GUEST

export const shouldBootstrapSession = (matchedRoutes) =>
  isPrivateAccess(getLastMatchedRoute(matchedRoutes)?.access)

export const isUnknownRoute = (matchedRoutes) =>
  !Array.isArray(matchedRoutes) || matchedRoutes.length === 0
